import(/* webpackMode: "eager" */ "/codebuild/output/src1051443037/src/apps/webapp/src/app/global-error.tsx");
